// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const front = [
	{
		path: "/login",
		name: "login",
		meta: {
			title: "登录",
			auth: false
		},
		component: _import('system/login/login.vue')
	},
	{
		path: "/logout",
		name: "logout",
		meta: {
			title: "退出",
			auth: false
		},
		component: _import('system/login/logout.vue')
	},
];

// 重新组织后导出
export default [
  ...front,
]